// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Table,
//   TableHeader,
//   TableColumn,
//   TableBody,
//   TableRow,
//   TableCell,
//   User,
//   Chip,
//   Spinner,
//   Button, // ADDED: import Button for delete action
// } from "@nextui-org/react";
// import axios from "axios";
// import { toast } from "react-toastify";

// const FlaggedComment = () => {
//   /* ─── STATE ───────────────────────────────────────── */
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const token = localStorage.getItem("accessToken");

//   /* ─── FETCH (no pagination) ───────────────────────── */
//   const fetchReports = useCallback(async () => {
//     if (!token) return toast.error("Missing auth token");

//     setLoading(true);
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_SERVER_URL}/admin/reports`,
//         {
//           headers: { authorization: `Bearer ${token}` },
//         }
//       );
//       // ADJUSTED: use res.data.data instead of res.data.details.reports
//       setReports(res.data.data);
//     } catch (err) {
//       console.error(err);
//       toast.error(err.response?.data?.message ?? "Couldn’t load reports");
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);

//   useEffect(() => {
//     fetchReports();
//   }, [fetchReports]);

//   /* ─── DELETE HANDLER ──────────────────────────────── */
//   const handleDelete = async (reportId) => {
//     if (!token) return toast.error("Missing auth token");

//     try {
//       await axios.delete(
//         `${process.env.REACT_APP_SERVER_URL}/admin/deletereport/${reportId}`,
//         {
//           headers: { authorization: `Bearer ${token}` },
//         }
//       );
//       // ADDED: remove the deleted report from state
//       setReports((prev) => prev.filter((r) => r.id !== reportId));
//       toast.success("Report deleted");
//     } catch (err) {
//       console.error(err);
//       toast.error(err.response?.data?.message ?? "Couldn’t delete report");
//     }
//   };

//   /* ─── UI ──────────────────────────────────────────── */
//   if (loading) {
//     return (
//       <div className="flex justify-center items-center h-56">
//         <Spinner label="Loading flagged comments…" />
//       </div>
//     );
//   }

//   return (
//     <div className="mt-6">
//       <Table aria-label="Flagged comments table" shadow="sm" fullWidth>
//         <TableHeader>
//           {/* <TableColumn>ID</TableColumn> */}
//           {/* <TableColumn>Comment ID</TableColumn> */}
//           <TableColumn>Reporter</TableColumn>
//           <TableColumn>Role</TableColumn>
//           <TableColumn>Reason</TableColumn>
//           <TableColumn>Date / Time</TableColumn>
//           <TableColumn>Action</TableColumn>{" "}
//           {/* ADDED: new column for delete button */}
//         </TableHeader>

//         <TableBody items={reports} emptyContent="No flagged comments.">
//           {(r) => (
//             <TableRow key={r.id}>
//               {/* <TableCell>{r.id}</TableCell> */}
//               {/* <TableCell>{r.comment_id}</TableCell> */}
//               <TableCell>
//                 <User
//                   name={`${r.user.first_name} ${r.user.last_name}`}
//                   description={`ID: ${r.user.id}`}
//                   avatarProps={{
//                     src: r.user.profile_id
//                       ? `/path/to/avatars/${r.user.profile_id}`
//                       : undefined,
//                   }}
//                 />
//               </TableCell>
//               <TableCell>{r.reported_by_role}</TableCell>
//               <TableCell>
//                 <Chip color="danger" size="sm" variant="flat">
//                   {r.reason}
//                 </Chip>
//               </TableCell>
//               <TableCell>{new Date(r.createdAt).toLocaleString()}</TableCell>
//               <TableCell>
//                 {/* ADDED: delete button */}
//                 <Button
//                   size="sm"
//                   color="danger"
//                   variant="flat"
//                   onClick={() => handleDelete(r.id)}
//                 >
//                   Delete
//                 </Button>
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </div>
//   );
// };

// export default FlaggedComment;

import React, {
  useState,
  useEffect,
  useCallback,
  useMemo, // ★ NEW
} from "react";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  User,
  Chip,
  Spinner,
  Button,
  Pagination, // ★ NEW
} from "@nextui-org/react";
import axios from "axios";
import { toast } from "react-toastify";

const FlaggedComment = () => {
  /* ─── STATE ───────────────────────────────────────── */
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ★ NEW – pagination state */
  const [page, setPage] = useState(1);
  const rowsPerPage = 6;

  const token = localStorage.getItem("accessToken");

  /* ─── FETCH (no pagination) ───────────────────────── */
  const fetchReports = useCallback(async () => {
    if (!token) return toast.error("Missing auth token");

    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/reports`,
        { headers: { authorization: `Bearer ${token}` } }
      );
      setReports(res.data.data);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message ?? "Couldn’t load reports");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  /* ─── DELETE HANDLER ──────────────────────────────── */
  const handleDelete = async (reportId) => {
    if (!token) return toast.error("Missing auth token");
    try {
      await axios.delete(
        `${process.env.REACT_APP_SERVER_URL}/admin/deletereport/${reportId}`,
        { headers: { authorization: `Bearer ${token}` } }
      );
      setReports((prev) => prev.filter((r) => r.id !== reportId));
      toast.success("Report deleted");
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message ?? "Couldn’t delete report");
    }
  };

  /* ★ NEW – derive rows for current page */
  const totalPages = Math.ceil(reports.length / rowsPerPage) || 1;
  const currentRows = useMemo(
    () => reports.slice((page - 1) * rowsPerPage, page * rowsPerPage),
    [reports, page]
  );

  /* ★ NEW – keep page in range if data shrinks */
  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [totalPages, page]);

  /* ─── UI ──────────────────────────────────────────── */
  if (loading) {
    return (
      <div className="flex justify-center items-center h-56">
        <Spinner label="Loading flagged comments…" />
      </div>
    );
  }

  return (
    <div className="mt-6 flex flex-col gap-4">
      <Table aria-label="Flagged comments table" shadow="sm" fullWidth>
        <TableHeader>
          <TableColumn>Reporter</TableColumn>
          <TableColumn>Role</TableColumn>
          <TableColumn>Reason</TableColumn>
          <TableColumn>Date / Time</TableColumn>
          <TableColumn>Action</TableColumn>
        </TableHeader>

        {/* ★ NEW – feed currentRows instead of reports */}
        <TableBody items={currentRows} emptyContent="No flagged comments.">
          {(r) => (
            <TableRow key={r.id}>
              <TableCell>
                <User
                  name={`${r.user.first_name} ${r.user.last_name}`}
                  description={`ID: ${r.user.id}`}
                  avatarProps={{
                    src: r.user.profile_id
                      ? `/path/to/avatars/${r.user.profile_id}`
                      : undefined,
                  }}
                />
              </TableCell>
              <TableCell>{r.reported_by_role}</TableCell>
              <TableCell>
                <Chip color="danger" size="sm" variant="flat">
                  {r.reason}
                </Chip>
              </TableCell>
              <TableCell>{new Date(r.createdAt).toLocaleString()}</TableCell>
              <TableCell>
                <Button
                  size="sm"
                  color="danger"
                  variant="flat"
                  onClick={() => handleDelete(r.id)}
                >
                  Delete
                </Button>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      {/* ★ NEW – pagination control */}
      <div className="flex justify-center">
        <Pagination
          page={page}
          total={totalPages}
          onChange={setPage}
          showControls
        />
      </div>
    </div>
  );
};

export default FlaggedComment;